export class ErrorModel {
    status: string;
    statusText: string;
    message: string;    
    errorMessage: string;
    title: string;
}
